import { Addresses } from '@/domain/addresses';
import { getChainConstant } from '@/domain/chain';
import useChainId from '@/hooks/useChainId';
import FloorV1TokenMerkleClaimAbi from '@/infrastructure/abis/FloorV1TokenMerkleClaim';
import { Address } from 'viem';
import { useReadContract } from 'wagmi';

const useLeaf = ({
  recipient,
  amount,
}: {
  recipient?: Address;
  amount?: bigint;
}) => {
  const chainId = useChainId();

  return useReadContract({
    functionName: 'leaf',
    abi: FloorV1TokenMerkleClaimAbi,
    address: getChainConstant(Addresses, chainId, 'FloorV1TokenMerkleClaim'),
    args: [recipient as Address, amount as bigint],
    chainId: chainId,
    query: {
      enabled: recipient != null && amount != null,
    },
  });
};

export default useLeaf;
